import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { fetchCallRecordWithEntityKey } from 'flow/actions/extension-actions';
import { getDecoratedCall } from 'flow/actions/cti-actions';
import { isAppCti } from 'flow/utils/app-utils';
// TODO: Re-enable when Ticket Details tab is added to the call record details page
// import {
//     fetchTicket,
//     setTicketViewMountStatus,
// } from 'flow/actions/tickets-action';
import { selectCallRecordFromKey } from 'flow/selectors/call-selectors';
import { useCallRecordExtendedTranscription } from './useCallRecordExtendedTranscription';
import { CallRecordKey } from 'flow/types/EntityKeys';

export const useCallRecordDetail = (
    callRecordKey: CallRecordKey,
    _viewContext: 'page' | 'modal',
) => {
    const dispatch = useAppDispatch();
    // const [ticketAccessDenied, setTicketAccessDenied] = useState(false);

    const callRecord = useAppSelector((state) =>
        selectCallRecordFromKey(state, callRecordKey),
    );

    // The key whose detail fetch has settled. List fetches land records in the
    // store without ticket scope (getExtensionCallRecords ignores the `tickets`
    // include — see call-record-fetch-includes), so an absent
    // omniTicketEntityKey means either "no ticket" or "nobody has asked yet".
    // Only this fetch, which does carry the scope, can tell the two apart.
    // Comparing against the current key makes the flag reset itself on
    // navigation, and a stale fetch settling late stamps the key it belongs to.
    const [keyWithSettledDetailFetch, setKeyWithSettledDetailFetch] =
        useState<CallRecordKey>();

    useEffect(() => {
        // Settled, not fulfilled: a failed fetch has to end the unknown state
        // too, or consumers waiting on it are stranded on a record that will
        // never resolve. The error itself is already dispatched by the action.
        const onSettled = () => setKeyWithSettledDetailFetch(callRecordKey);
        void dispatch(fetchCallRecordWithEntityKey(callRecordKey)).then(
            onSettled,
            onSettled,
        );
    }, [callRecordKey, dispatch]);

    const number = callRecord?.getIn(['number', 'number']);
    const isCti = useAppSelector(isAppCti);
    useEffect(() => {
        if (!isCti || !number) return;
        dispatch(getDecoratedCall(number));
    }, [isCti, number, dispatch]);

    const ticketKey = callRecord?.get('omniTicketEntityKey');
    const ticketScopeIsResolved = keyWithSettledDetailFetch === callRecordKey;

    // TODO: Re-enable when Ticket Details tab is added to the call record details page
    // useEffect(() => {
    //     if (!ticketKey) return undefined;
    //     dispatch(fetchTicket(ticketKey)).catch(() => {
    //         setTicketAccessDenied(true);
    //     });
    //     dispatch(setTicketViewMountStatus(true, ticketKey, viewContext));
    //     return () => {
    //         dispatch(setTicketViewMountStatus(false, ticketKey, viewContext));
    //     };
    // }, [dispatch, ticketKey, viewContext]);

    const extendedTranscription =
        useCallRecordExtendedTranscription(callRecordKey);

    return {
        callRecord,
        ticketKey,
        ticketScopeIsResolved,
        // ticketAccessDenied,
        extendedTranscription,
    };
};
